<div class="redirect-cta-container padding-object-6">
	<div class="dz-flex dz-justify-content-center dz-text-18 text-align-center margin-bottom-object-6" dcrHTMLKey="REDIRECT_TEXT">
		Model Evaluator has been integrated into BlackRock Advisor Center 360°
	</div>
	<div class="margin-top-object-3 dz-flex dz-justify-content-center">
		<button class="dz-btn dz-btn-primary dz-text-18" dz-button (click)="onRedirectClick()">
			<span dcrHTMLKey="REDIRECT_CTA_LABEL" class="margin-right-object-1">Click here to launch the platform</span>
			<dz-icon type="arrow-right"></dz-icon>
		</button>
	</div>
</div>
